import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function CirclelcCheck({
  color,
  size,
  style,
  noFill,
  className,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ')}
      color={color}
      fontSize={size}
      style={style}
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12 2C17.5231 2 22 6.47686 22 12C22 17.5231 17.5231 22 12 22C6.47686 22 2 17.5231 2 12C2 6.47686 6.47686 2 12 2ZM12 3C7.02914 3 3 7.02914 3 12C3 16.9709 7.02914 21 12 21C16.9709 21 21 16.9709 21 12C21 7.02914 16.9709 3 12 3ZM8.13842 11.67C8.32298 11.4877 8.6222 11.4877 8.80676 11.67L11.0148 13.8506L15.1718 9.15937C15.3436 8.96539 15.6422 8.94575 15.8386 9.1155C16.035 9.28524 16.0549 9.58009 15.883 9.77406L11.3934 14.8406C11.2134 15.0438 10.8969 15.0542 10.7036 14.8633L8.13842 12.33C7.95386 12.1478 7.95386 11.8523 8.13842 11.67Z'
        stroke='currentColor'
      />
    </svg>
  );
}
